module.exports = __webpack_public_path__ + "static/twitter-416c8f1397daf5ce492183c1749b03c8.svg";